// fileDownloader.js
import axios from 'axios';

export async function downloadFile(url) {
  try {
    // 使用 axios 获取文件
    const response = await axios.get(url, {
      responseType: 'blob'  // 确保响应类型为 blob
    });

    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    // 从 URL 中提取文件名，并去掉?后面的查询参数
    let filename = url.split('/').pop();
    filename = filename.split('?')[0]; // 去掉 ? 后面的部分

    link.download = filename;

    // 触发点击事件以下载文件
    document.body.appendChild(link);
    link.click();

    // 移除链接元素处理
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error('文件下载出错:', error);
  }
}
